import { FC } from 'react';
import classNames from 'classnames';

import styles from './TierExplanationModal.module.scss';

interface Props {
  name: string;
  text: string;
  smallSize?: boolean;
}

const TierItem: FC<Props> = ({ name, text, smallSize = false }) => (
  <div className={classNames(styles[name], { [styles['small-size']]: smallSize })}>
    <span className={styles['pro-tier-icon-detail']}>
      <img alt={`Tier ${name}`} src={`/static/images/tiers/${name}.svg`} />
      <span>{text}</span>
    </span>
  </div>
);

export default TierItem;
